/*--------------------------------------------------------------
# Custom scripts for FAQs block
--------------------------------------------------------------*/

let accordionItemsToBeFocused = document.querySelectorAll(".accordion-collapse");

accordionItemsToBeFocused.forEach((el)=>{
    el.addEventListener('shown.bs.collapse',(e)=>{
        window.location.href = '#' + el.id
    })
})